import _size from "lodash/size";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { string, arrayOf, shape, func, bool, oneOfType, number, oneOf } from 'prop-types';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import Accordion from "semantic-ui-react/dist/es/modules/Accordion/Accordion.js";
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
import { Icon, ICON_NAMES } from "../../../elements/Icon";
import { Modal } from "../../../elements/Modal";
import { Submenu } from "../../../elements/Submenu";
import { testidFactory } from "../../../../utils/testid";
import { Logo } from "../../../elements/Logo";
import { PHONE_PREFIX } from "../constants";
var TEST_ID_PREFIX = 'MobileHeader';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var currencyNoResultsText = _ref.currencyNoResultsText,
      currencyOptions = _ref.currencyOptions,
      currencyValue = _ref.currencyValue,
      languageOptions = _ref.languageOptions,
      languageValue = _ref.languageValue,
      logoHref = _ref.logoHref,
      logoSize = _ref.logoSize,
      logoSizes = _ref.logoSizes,
      logoSrc = _ref.logoSrc,
      logoSrcSet = _ref.logoSrcSet,
      logoSubText = _ref.logoSubText,
      logoText = _ref.logoText,
      navigationItems = _ref.navigationItems,
      onChangeCurrency = _ref.onChangeCurrency,
      onChangeLanguage = _ref.onChangeLanguage,
      phoneNumber = _ref.phoneNumber;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      activeItem = _useState2[0],
      setActiveItem = _useState2[1];

  useEffect(function () {
    if (navigationItems.length > 0) {
      setActiveItem(navigationItems[0].text);
    }
  }, [navigationItems.length]);

  var onMenuLinkClick = function onMenuLinkClick(text) {
    setActiveItem(text);
  };

  return React.createElement(Modal, {
    className: "hidden-contact-header-modal",
    closeIcon: React.createElement(Icon, {
      labelText: "Close",
      name: "close"
    }),
    "data-testid": testid(),
    header: React.createElement(Logo, {
      logoHref: logoHref,
      logoSize: logoSize,
      logoSizes: logoSizes,
      logoSrc: logoSrc,
      logoSrcSet: logoSrcSet,
      logoSubText: logoSubText,
      logoText: logoText
    }),
    isFullscreen: true,
    trigger: React.createElement(Icon, {
      name: ICON_NAMES.BARS
    })
  }, React.createElement("div", null, React.createElement(Menu, {
    text: true,
    vertical: true
  }, navigationItems.map(function (_ref2, index) {
    var subItems = _ref2.subItems,
        text = _ref2.text,
        href = _ref2.href;
    return _size(subItems) ? React.createElement(Accordion, {
      as: Menu.Item,
      key: buildKeyFromStrings(text, index),
      panels: [{
        title: {
          content: text,
          key: buildKeyFromStrings(text, index)
        },
        content: {
          content: subItems.map(function (_ref3, index) {
            var text = _ref3.text,
                href = _ref3.href;
            return React.createElement(Menu.Item, {
              active: text === activeItem,
              "data-testid": testid("accordionItem_".concat(index)),
              href: href,
              key: buildKeyFromStrings(text, index),
              link: true,
              onClick: function onClick() {
                return onMenuLinkClick(text);
              }
            }, text);
          }),
          key: buildKeyFromStrings(index, text)
        }
      }]
    }) : React.createElement(Menu.Item, {
      active: text === activeItem,
      "data-testid": testid("MobileHeaderItem_".concat(index)),
      href: href,
      key: buildKeyFromStrings(text, index),
      link: true,
      onClick: function onClick() {
        return onMenuLinkClick(text);
      }
    }, text);
  })), React.createElement(Menu, {
    vertical: true
  }, _size(languageOptions) > 1 && React.createElement(Menu.Item, null, React.createElement(Submenu, {
    items: languageOptions,
    name: "language",
    onChange: onChangeLanguage,
    value: languageValue,
    willOpenAbove: true
  })), _size(currencyOptions) > 1 && React.createElement(Menu.Item, null, React.createElement(Submenu, {
    isSearchable: true,
    items: currencyOptions,
    name: "currency",
    noResultsText: currencyNoResultsText,
    onChange: onChangeCurrency,
    value: currencyValue,
    willOpenAbove: true
  })), !!phoneNumber && React.createElement(Menu.Item, {
    className: "is-selectable"
  }, React.createElement("a", {
    href: "".concat(PHONE_PREFIX).concat(phoneNumber.replace(/\s/g, ''))
  }, React.createElement(Icon, {
    labelText: phoneNumber,
    name: ICON_NAMES.PHONE
  }))))));
};
Component.defaultProps = {
  currencyNoResultsText: '',
  currencyOptions: [],
  currencyValue: null,
  languageOptions: [],
  languageValue: null,
  logoHref: '',
  logoSize: 'medium',
  logoSizes: undefined,
  logoSrc: undefined,
  logoSrcSet: undefined,
  logoSubText: '',
  logoText: '',
  onChangeCurrency: undefined,
  onChangeLanguage: undefined,
  phoneNumber: ''
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  currencyNoResultsText: string,
  currencyOptions: arrayOf(shape({
    text: string.isRequired,
    value: oneOfType([bool, number, string])
  })),
  currencyValue: oneOfType([bool, number, string]),
  languageOptions: arrayOf(shape({
    text: string.isRequired,
    value: oneOfType([bool, number, string])
  })),
  languageValue: oneOfType([bool, number, string]),
  logoHref: string,
  logoSize: oneOf(['medium', 'large', 'huge']),
  logoSizes: string,
  logoSrc: string,
  logoSrcSet: string,
  logoSubText: string,
  logoText: string,
  navigationItems: arrayOf(shape({
    href: string,
    subItems: arrayOf(shape({
      href: string.isRequired,
      target: string,
      text: string.isRequired
    })),
    target: string,
    text: string.isRequired
  })).isRequired,
  onChangeCurrency: func,
  onChangeLanguage: func,
  phoneNumber: string
} : {};